import { SnackbarAction as n } from "./SnackbarAction";
import { SnackbarActionPrimary as c } from "./SnackbarActionPrimary";
import { SnackbarProvider as o } from "./SnackbarProvider";
import { useSnackbar as e } from "notistack";

var p = {
  Action: n,
  ActionPrimary: c,
  Provider: o
},
    d = function d() {
  var _e = e(),
      a = _e.enqueueSnackbar,
      r = _e.closeSnackbar;

  return {
    addSnackbar: a,
    removeSnackbar: r
  };
};

export { p as Snackbar, d as useSnackbar };